angular.module('app').config(function (universityBrandingSettingsProvider) {
  universityBrandingSettingsProvider.setBrandingDefaultColor({
    cssDefault: 'default',
    defaultColor: '#333d47',
    defaultWhite: '#fff'
  });
});
